<template>
    <div>
        <v-row align="center" class="text-center py-3">
            <!-- Product Image & Name -->
            <v-col cols="5" class="text-left d-flex align-center">
                <v-img :src="getImageUrl(item.productImage)" max-width="80" max-height="80" contain class="mr-4 rounded"
                    style="border: 1px solid #eee;"></v-img>
                <div>
                    <div class="subtitle-2">{{ item.productName }}</div>
                    <div v-if="item.variant" class="caption grey--text">
                        {{ getVariantText(item.variant) }}
                    </div>
                </div>
            </v-col>

            <!-- Price -->
            <v-col cols="3">
                ฿ {{ formatPrice(item.price) }}
            </v-col>

            <!-- Quantity -->
            <v-col cols="2">
                {{ item.quantity }}
            </v-col>

            <!-- Subtotal -->
            <v-col cols="2" class="font-weight-bold">
                ฿ {{ formatPrice(item.subtotal) }}
            </v-col>
        </v-row>
        <v-divider v-if="!lastItem"></v-divider>
    </div>
</template>

<script>
import { getImageUrl } from "@/utils/image";
export default {
    name: "OrderItem",
    props: {
        item: {
            type: Object,
            required: true,
        },
        lastItem: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getImageUrl,
        formatPrice(val) {
            return Number(val).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
        getVariantText(variant) {
            if (!variant) return "";
            const parts = [];
            if (variant.color) parts.push(variant.color);
            if (variant.size) parts.push(variant.size);
            return parts.length > 0 ? parts.join(" ") : "";
        },
    },
};
</script>

<style scoped></style>
